/*****************************************
 * Scripts relatifs à la demande de devis
 *****************************************/


const
  stepLinks = document.querySelectorAll('[data-trigger^=\'step\']'),
  stepFieldsets = document.querySelectorAll('[data-target^=\'step\']'),
  prevNextBtns = document.querySelectorAll('[data-goto]'),
  submitBtn = document.querySelector('#quote_request_submit'),
  header = document.querySelector('header');

const stepsOrder = [];
stepFieldsets.forEach(stepField => {
  stepsOrder.push(stepField.dataset.target);
});

// Step 1 - Profil
const profiles = Array.from(document.getElementsByName('quote_request[profile]'));

profiles.forEach(function (profile) {
  profile.addEventListener('click', displayNextStep.bind(this, 'stepOne', 'stepTwo'));
});

// Step 2 - Collections
prevNextBtns.forEach((prevNextBtn) => {
  prevNextBtn.addEventListener('click', function (e) {
    e.preventDefault();
    navigateThroughButton(prevNextBtn);
  });
});

// Step 3 - Localisation
let stepThree = document.querySelector('[data-target=\'stepThree\']'),
  address = stepThree.querySelector('#quote_request_address'),
  moreAddress = stepThree.querySelector('#quote_request_moreAddress'),
  postalCode = stepThree.querySelector('#quote_request_postalCode'),
  city = stepThree.querySelector('#quote_request_city'),
  stepThreeBtnsContainer = stepThree.querySelector('[data-target=\'btns-container\']'),
  addressBtn = document.querySelector('[data-goto="stepThreeBis"]'),
  suppliersAjaxRoute = document.querySelector('#form-values').dataset.suppliersAjaxRoute,
  modal = document.querySelector('.modal');

modal.querySelector('[data-dismiss="modal"]').addEventListener('click', e => {
  modal.style.display = 'none';
  modal.classList.remove('show');
});

// Step 4 - Infos persos
const stepFour = document.querySelector('[data-target=\'stepFour\']'),
  radioMale = stepFour.querySelector('#quote_request_gender_0'),
  radioFemale = stepFour.querySelector('#quote_request_gender_1'),
  firstName = stepFour.querySelector('#quote_request_firstName'),
  lastName = stepFour.querySelector('#quote_request_lastName'),
  email = stepFour.querySelector('#quote_request_email'),
  telephone = stepFour.querySelector('#quote_request_phone');

const stepMatrix = [
  {
    btnsContainer: stepThreeBtnsContainer,
    fields: [
      {
        element: address,
        jsEvent: 'input',
        validation: {
          valid: false,
        },
      }, {
        element: postalCode,
        jsEvent: 'input',
        validation: {
          valid: false,
          format: 'onlyNumbers',
          requiredLength: 5,
        },
      },
      {
        element: city,
        jsEvent: 'input',
        validation: {
          valid: false,
        },
      },
    ],
  }, {
    btnsContainer: 'finalBtns',
    fields: [
      {
        element: radioMale,
        jsEvent: 'change',
        validation: {
          valid: false,
          format: 'isRadio',
        },
      },
      {
        element: radioFemale,
        jsEvent: 'input',
        validation: {
          valid: false,
          format: 'isRadio',
        },
      },
      {
        element: firstName,
        jsEvent: 'input',
        validation: {
          valid: false,
        },
      },
      {
        element: lastName,
        jsEvent: 'input',
        validation: {
          valid: false,
        },
      },
      {
        element: email,
        jsEvent: 'input',
        validation: {
          valid: false,
          format: 'isEmail',
        },
      },
      {
        element: telephone,
        jsEvent: 'input',
        validation: {
          valid: false,
          format: 'onlyNumbers',
          requiredLength: 10,
        },
      },
    ],
  },
];

window.addEventListener('load', function () {

  const profiles = document.querySelectorAll('[name=\'quote_request[profile]\']');
  let alreadyFilled = false;

  let profilesArray = [];
  profiles.forEach((profile) => {
    profilesArray.push(profile.checked);
  });
  alreadyFilled = profilesArray.some(x => x === true);

  if (alreadyFilled) {
    stepMatrix.forEach(dataset => {
      const { fields } = dataset;

      fields.forEach(({ element: field, validation }) => {
        checkFieldStatus(fields, field, validation, dataset);
      });
    });

  }
});

stepMatrix.forEach(dataset => {
  setFieldStatus(dataset);
});

// Au clic sur suivant, on récupère l'adresse, pour déterminer une liste de distributeurs à proximité
addressBtn.addEventListener('click', function (e) {
  e.preventDefault();

  let promise = new Promise(function (resolve, reject) {
    const { fields } = stepMatrix[0];

    fields.forEach(dataset => {
      const { element: field, validation } = dataset;
      const value = field.value,
        formGroup = field.closest('.form-group');
      const { format, requiredLength } = validation;

      if (value !== '') {
        // Si le champ n'est pas vide
        if (format === 'onlyNumbers') {
          // Si une exigence de format en nombre est donnée
          if (!isNaN(value)) {
            if (value.length === Number(requiredLength)) {
              // Si une exigence en nombre de caractères est donnée
              if (formGroup.classList.contains('has-error')) {
                formGroup.classList.remove('has-error');
              }
              validation.valid = true;
            } else {
              formGroup.classList.add('has-error');
              validation.valid = false;
            }
          } else {
            formGroup.classList.add('has-error');
            validation.valid = false;
          }
        } else {
          if (formGroup.classList.contains('has-error')) {
            formGroup.classList.remove('has-error');
          }
          validation.valid = true;
        }
      } else {
        formGroup.classList.add('has-error');
        validation.valid = false;
      }
      resolve('done');
      reject('Impossible de terminer la vérification des champs.');

    });
  });
  promise
    .then(
      function (result) {
        const { fields } = stepMatrix[0];
        let flag = true;
        fields.forEach(({ validation: { valid } }) => {
          if (!valid) {
            flag = false;
          }
        });
        return flag;
      },
    )
    .then(
      function (result) {
        if (result === true) {
          //Update addresses
          address = stepThree.querySelector('#quote_request_address');
          moreAddress = stepThree.querySelector('#quote_request_moreAddress');
          postalCode = stepThree.querySelector('#quote_request_postalCode');
          city = stepThree.querySelector('#quote_request_city');

          let completeAddress = `${address.value} ${moreAddress.value} ${postalCode.value} ${city.value}`;

          let request = new Request(
            suppliersAjaxRoute, {
              method: 'POST',
              body: completeAddress,
            });

          fetch(request)
            .then(response => response.json())
            .then(data => {
              if (0 < data.length) {

                submitBtn.removeAttribute('disabled');

                // Ajoute les distributeurs à l'étape 3 bis et navigue vers celle-ci
                //addSuppliersToStepThreeBis(data);
                //permet de passer par l'étape 3 bis de selection de storiste à proximité du domicile
                //navigateThroughButton(addressBtn,true);

                //permet de sauter l'étape 3 bis de selection de storiste à proximité du domicile
                jumpStepThreeBis();

              } else if (data.error) {
                displayFormError(data.error);
              } else {
                // Ouvre la modale
                modal.classList.add('show');
                modal.style.display = 'block';

              }
            });
        }

      },
      error => console.log(error),
    );
});

submitBtn.addEventListener('click', () => {
  stepMatrix.forEach(dataset => {
    const { fields } = dataset;

    fields.forEach(({ element: field, validation }) => {
      checkFieldStatus(fields, field, validation, dataset);
    });
  });
});

// Fonctions

/**
 * Avance le wizard à l'étape suivante
 * Affiche le fieldset de l'étape suivante
 *
 * @param oldStep {text} identifiant de l'étape que l'on quitte
 * @param newStep {text} identifiant de létape à afficher
 */
function displayNextStep(oldStep, newStep) {

  const oldStepLink = document.querySelector(`[data-trigger='${oldStep}']`),
    oldStepLinkNumber = oldStepLink.querySelector('.step__number'),
    newStepLink = document.querySelector(`[data-trigger='${newStep}']`),
    oldStepFieldset = document.querySelector(`[data-target='${oldStep}']`),
    newStepFieldset = document.querySelector(`[data-target='${newStep}']`);

  if (oldStepLink.classList.contains('step--active')) {
    oldStepLink.classList.remove('step--active');
    oldStepLinkNumber.innerHTML = '';
    newStepLink.classList.add('step--active');
    oldStepLink.classList.add('step--done');
  }

  if (oldStepFieldset.classList.contains('active')) {
    oldStepFieldset.classList.remove('active');
    newStepFieldset.classList.add('active');
  }

  goUpSmoothly();
}

stepLinks.forEach((stepLink) => {
  stepLink.addEventListener('click', function () {
    const stepNumber = stepLink.dataset.trigger,
      stepValue = stepLink.dataset.value,
      fieldset = document.querySelector(`[data-target="${stepNumber}"]`);

    if (stepLink.classList.contains('step--done')) {
      stepLink.classList.remove('step--done');
      stepLink.classList.add('step--active');
      stepLink.querySelector('.step__number').innerHTML = stepValue;
      fieldset.classList.add('active');

      // Retire les états actifs aux étapes supérieurs
      for (let i = Number(stepValue) + 1; i <= [...stepLinks].length; i++) {
        const stepSup = document.querySelector(`[data-value="${i}"]`),
          stepSupTrigger = stepSup.dataset.trigger,
          fieldsetThreeBis = document.querySelector(`[data-target="stepThreeBis"]`),
          relatedFieldstep = document.querySelector(`[data-target="${stepSupTrigger}"]`);

        stepSup.classList.contains('step--done') ? stepSup.classList.remove('step--done') : null;
        stepSup.classList.contains('step--active') ? stepSup.classList.remove('step--active') : null;
        stepSup.querySelector('.step__number').innerHTML = i;

        relatedFieldstep.classList.contains('active') ? relatedFieldstep.classList.remove('active') : null;
        fieldsetThreeBis.classList.contains('active') ? fieldsetThreeBis.classList.remove('active') : null;

      }
    }
  });
});

/**
 * Affiche le fieldset de l'étape concernée pr le clic sur le bouton "suivant" ou "précédent"
 * Met en actif cette étape dans le wizard
 *
 * @param prevNextBtn {element} Le bouton cliqué
 * @param force
 */
function navigateThroughButton(prevNextBtn, force = false) {

  let stepNumber = prevNextBtn.dataset.goto;

  // On empêche le passage à l'étape 4 bis s'il n'est pas forcé (suite à un retour ajax positif)
  if (stepNumber === 'stepThreeBis' &&
    !force) {
    return;
  }

  // Avant de passer à l'étape 4, on garde une trace du distributeur choisi et on envoie la requete GTM
  if (stepNumber === 'stepFour') {
    dataLayer.push({
      'event': 'VirtualPageview',
      'virtualURL': '/devis-gratuit/infos',
      'virtualTitle': 'Devis Gratuit - Vos informations personnelles',
    });
    /*    let chosenSupplier = document.querySelector('[name="store-selector"]:checked'),
            supplierInput = document.querySelector('#quote_request_supplier');
        supplierInput.value = chosenSupplier.dataset.apiIdentifier;*/
  }

  // Gestion du wizard
  if (stepNumber !== 'stepThreeBis') {
    const newStepLink = document.querySelector(`[data-trigger='${stepNumber}']`);
    stepLinks.forEach(stepLink => {
      if (stepLink.classList.contains('step--active')) {
        stepLink.classList.remove('step--active');
      }
    });
    if (newStepLink.classList.contains('step--done')) {
      newStepLink.classList.remove('step--done');
      newStepLink.querySelector('.step__number').innerHTML = newStepLink.dataset.value;
      newStepLink.classList.add('step--active');
    } else {
      newStepLink.classList.add('step--active');
    }
  }

  // On récupère l'ordre de l'étape sur laquelle on vient d'arriver
  const currentStepPosition = stepsOrder.indexOf(stepNumber);

  if (currentStepPosition !== 3) {
    // Tant que l'on n'est pas en position 3 (correspondant à la threeBis, l'affichage du magasin le + proche), on applique les style de changement d'étape
    for (let i = 0; i < currentStepPosition; i++) {
      // On boucle sur toutes les étapes qui précèdent

      if (i < 3) {
        // Il n'y a que 4 entrées dans stepLinks (stepsLinks != stepsOrder), stepLinks[3] correspond à l'étape 4 (finale) donc
        stepLinks[i].querySelector('.step__number').innerHTML = '';
        stepLinks[i].classList.add('step--done');
      }
    }
  }

  stepFieldsets.forEach(stepField => {
    if (stepField.classList.contains('active')) {
      stepField.classList.remove('active');
    }
  });

  const newStepFieldset = document.querySelector(`[data-target='${stepNumber}']`);
  newStepFieldset.classList.add('active');

  goUpSmoothly();
}

/**
 * Valide les champs d'une étape
 *
 * @param dataset
 */
function validFields(dataset) {
  const { fields } = dataset;

  let flag = true;
  fields.forEach(({ validation: { valid } }) => {
    if (!valid) {
      flag = false;
    }
  });

  return flag;
}

/**
 * Vérifie si les champs requis par étapes sont correctement remplis, et passe leur validation à true le cas échéant
 *
 * @param stepDataset {object} l'étape qui doit être validée
 */
function setFieldStatus(stepDataset) {
  const { fields } = stepDataset;
  fields.forEach(dataset => {
    const { element: field, jsEvent, validation } = dataset;

    field.addEventListener(jsEvent, () => {
      checkFieldStatus(fields, field, validation, stepDataset);
    });
  });
}

/**
 * Vérifie les champs un à un
 *
 *
 */
function checkFieldStatus(fields, field, validation, stepDataset) {
  const value = field.value,
    formGroup = field.closest('.form-group');

  const { format, requiredLength } = validation;

  if (value !== '') {
    // Si le champ n'est pas vide
    if (format === 'onlyNumbers') {
      // Si une exigence de format en nombre est donnée
      if (!isNaN(value)) {
        if (value.length === Number(requiredLength)) {
          // Si une exigence en nombre de caractères est donnée
          if (formGroup.classList.contains('has-error')) {
            formGroup.classList.remove('has-error');
          }
          validation.valid = true;
        } else {
          formGroup.classList.add('has-error');
          validation.valid = false;
        }
      } else {
        formGroup.classList.add('has-error');
        validation.valid = false;
      }
    } else if (format === 'isEmail') {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        if (formGroup.classList.contains('has-error')) {
          formGroup.classList.remove('has-error');
        }
        validation.valid = true;
      } else {
        formGroup.classList.add('has-error');
        validation.valid = false;
      }
    } else if (format === 'isRadio') {
      const inputsRadios = fields.filter(inputRadio => inputRadio.validation.format === 'isRadio');
      let flag = false;
      new Promise(resolve => {
        inputsRadios.forEach((radio) => {
          radio.element.checked ? flag = true : null;
        });
        resolve();
      }).then(() => {
        if (flag === true) {
          if (formGroup.classList.contains('has-error')) {
            formGroup.classList.remove('has-error');
            validation.valid = true;
          }
        } else {
          formGroup.classList.add('has-error');
          validation.valid = true;
        }
      });
    } else {
      if (formGroup.classList.contains('has-error')) {
        formGroup.classList.remove('has-error');
      }
      validation.valid = true;
    }
  } else {
    formGroup.classList.add('has-error');
    validation.valid = false;
  }
  validFields(stepDataset);
}

/**
 * Remonte en haut de page avec animation
 */
function goUpSmoothly() {
  const goToCoordY = document.querySelector('form[name=\'quote_request\']').getBoundingClientRect().top;
  let stepsAbsY;

  if (window.scrollY === 0) {
    stepsAbsY = (goToCoordY + window.scrollY) - 50;
  } else {
    stepsAbsY = goToCoordY + window.scrollY;
  }

  window.scrollTo({
    top: stepsAbsY,
    left: 0,
    behavior: 'smooth',
  });

  setTimeout(function () {
    header.classList.remove('is-show');
  }, 100);
}

/**
 * Boucle sur les distributeurs et les ajoute à la vue
 *
 * @param suppliers
 */
function addSuppliersToStepThreeBis(suppliers) {

  // Removal of existing items from the list
  removeSuppliersItems();

  let html = `
      <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3" data-content="supplier">
        <p class="">Vous êtes actuellement associé au magasin suivant :</p>
        <ul class="nearest-stores">
`;

  suppliers.forEach(function (supplier, index) {
    let loop = index + 1,
      checked = 1 === loop ? 'checked="checked"' : '';

    html += `
      <li>
        <input type="radio" id="choice${loop}" name="store-selector" class="sr-only" data-api-identifier="${supplier.api_identifier}" ${checked}>
        <label for="choice${loop}">${supplier.title}</label>
    `;

    if (1 < suppliers.length &&
      1 === loop) {
      html += `
          <p class="mt-3">Vous pouvez également choisir un autre magasin proche de chez vous :</p>
        `;
    }

    html += `</li>`;
  });

  html += `
        </ul>
      </div>
  `;

  dataLayer.push({
    'event': 'VirtualPageview',
    'virtualURL': '/devis-gratuit/magasin',
    'virtualTitle': 'Devis Gratuit - Votre adresse',
  });
  const row = document.querySelector('[data-target="stepThreeBis"] .row');

  row.innerHTML = html + row.innerHTML;
  row.querySelectorAll('[data-goto]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      navigateThroughButton(btn);
    });
  });
}

/**
 * Removal of existing items from the list
 *
 * @return void
 */
function removeSuppliersItems() {
  let suppliers = document.querySelector('[data-content="supplier"]');
  if (suppliers !== null) {
    suppliers.remove();
  }
}

function displayFormError(message) {
  let error = '';
  switch (message) {
    case 'address-not-valid' :
      error = 'Votre adresse n\'a pas été reconnue.';
      break;
    default :
      error = 'Erreur inconnue lors du traitement du formulaire.';
  }

  let html = '<span class="col-12 text-danger text-center m-auto">' + error + '</span>';

  let row = document.querySelector('[data-target="stepThree"] .row');

  // Replace already existing message
  row.innerHTML = row.innerHTML.replace(html, '');
  row.innerHTML = html + row.innerHTML;
}

// la fonction permet de sauter l'étape 3 bis.
// Cela est la même fonction que navigateThroughButton() mais on impose le stepNumber en 4 nous permettant
// de passer directement à la dernière étape "renseignez vos informations personnelles"
function jumpStepThreeBis() {
  var stepNumber = 'stepFour';

  dataLayer.push({
    'event': 'VirtualPageview',
    'virtualURL': '/devis-gratuit/infos',
    'virtualTitle': 'Devis Gratuit - Vos informations personnelles',
  });

  // Gestion du wizard
  const newStepLink = document.querySelector(`[data-trigger='${stepNumber}']`);
  stepLinks.forEach(stepLink => {
    if (stepLink.classList.contains('step--active')) {
      stepLink.classList.remove('step--active');
    }
  });
  if (newStepLink.classList.contains('step--done')) {
    newStepLink.classList.remove('step--done');
    newStepLink.querySelector('.step__number').innerHTML = newStepLink.dataset.value;
    newStepLink.classList.add('step--active');
  } else {
    newStepLink.classList.add('step--active');
  }

  // On récupère l'ordre de l'étape sur laquelle on vient d'arriver
  const currentStepPosition = stepsOrder.indexOf(stepNumber);

  // Tant que l'on n'est pas en position 3 (correspondant à la threeBis, l'affichage du magasin le + proche), on applique les style de changement d'étape
  for (let i = 0; i < currentStepPosition; i++) {
    // On boucle sur toutes les étapes qui précèdent

    if (i < 3) {
      // Il n'y a que 4 entrées dans stepLinks (stepsLinks != stepsOrder), stepLinks[3] correspond à l'étape 4 (finale) donc
      stepLinks[i].querySelector('.step__number').innerHTML = '';
      stepLinks[i].classList.add('step--done');
    }
  }

  stepFieldsets.forEach(stepField => {
    if (stepField.classList.contains('active')) {
      stepField.classList.remove('active');
    }
  });

  const newStepFieldset = document.querySelector(`[data-target='${stepNumber}']`);
  newStepFieldset.classList.add('active');

  goUpSmoothly();
}
